export const createMessage = (type, content, extractedData = {}, additionalProps = {}) => ({
  id: Date.now() + Math.random(),
  type,
  content,
  timestamp: new Date(),
  extractedData,
  ...additionalProps
});

export const createConversationEntry = (role, content) => ({ role, content });

export const parseMCPError = (data) => {
  let errorMessage = 'El sistema de IA no pudo procesar tu solicitud.';
  let errorDetails = '';
  
  if (data.content && data.content[0]) {
    if (data.content[0].type === 'json' && data.content[0].json) {
      // Structured error response
      const errorData = data.content[0].json;
      errorMessage = `Error: ${errorData.error || 'Error desconocido'}`;
      if (errorData.stack) {
        errorDetails = `\n\nDetalles técnicos:\n${errorData.stack}`;
      }
      if (errorData.executionTime) {
        errorDetails += `\nTiempo de ejecución: ${errorData.executionTime}`;
      }
    } else if (data.content[0].text) {
      // Text error response
      try {
        const errorData = JSON.parse(data.content[0].text);
        if (errorData.success === false) {
          errorMessage = 'El sistema de IA no pudo procesar tu solicitud.';
          errorDetails = '\n\nDetalles: El MCP tool retornó success: false';
        }
      } catch (e) {
        errorMessage = `Error del sistema: ${data.content[0].text}`;
      }
    }
  }
  
  return errorMessage + errorDetails;
};

export const parseMCPResponse = (data) => {
  let responseData = data;
  if (data.content && data.content[0] && data.content[0].text) {
    try {
      const parsedContent = JSON.parse(data.content[0].text);
      responseData = parsedContent;
    } catch (e) {
      console.log('⚠️ [Frontend] Could not parse MCP content:');
    }
  }
  return responseData;
};
